import { useState } from "react";
import { func, number, arrayOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { createCustomWorkTypeQuery, createRateCardTeamMemberQuery } from "@query";
import { useWorkspaceWebsocket } from "@hooks";
import {
  ValueCell,
  PinnableCell,
  RowGroup,
  Row,
  ExpandContainer,
} from "@tools";
import { CircularProgress, IconButton } from "@material-ui/core";
import { RateNameInput } from "./RateNameInput";
import { Close } from "@material-ui/icons";
import { pick } from "lodash";

export const NewRateElement = ({
  level,
  usedElementNames,
  parentId,
  onCreate,
  onCancel,
}) => {
  const { t } = useTranslation();
  const socket = useWorkspaceWebsocket();
  
  const [ isLoading, setLoading ] = useState(false);
  
  const createCustomWorkType = async (newWorkTypeName) => {
    if (!newWorkTypeName.length) return;
    setLoading(true);
    if (!parentId) {
      const newWorkType = await createCustomWorkTypeQuery(newWorkTypeName);
      
      onCreate(null, {
        ...pick(newWorkType, ["id", "name", "backgroundColor"]),
        categoryId: newWorkType.rateCardCategoryId,
        roles: newWorkType.rateCardCategoryRoles,
        salesRate: 0,
        costRate: 0,
        removable: true,
      });
      socket?.requestWorkTypeCreate(newWorkType);
    } else {
      const newRole = await createRateCardTeamMemberQuery(parentId, newWorkTypeName, usedElementNames.length);
      onCreate(parentId, newRole);
    }
    
    onCancel();
    setLoading(false);
  };

  return (
    <RowGroup tableDepth={level} isStatic>
      <Row
        useExpandCell
        visible
        tableDepth={level}
        isFirstGroupRow={level === 1}
        isLastGroupRow
      >
        <PinnableCell
          keepSmallestSize
          pinnedLeft
          tableDepth={level}
          allowOverflowDisplay
          containers={
            <ExpandContainer tableDepth={level} noArrow={level === 1} />
          }
        >
          <RateNameInput
            onAccept={createCustomWorkType}
            usedElementNames={usedElementNames}
            placeholder={t(`views.settings.projects.rate_card.${level === 1 ? "new_work_type" : "new_team_member"}`)}
            autoFocus
          />
        </PinnableCell>

        <ValueCell size="small" />
        <ValueCell size="large" extendPadding />
        <ValueCell size="large" extendPadding />

        <ValueCell size="small">
          <IconButton onClick={onCancel} size="small">
            {isLoading ? (
              <CircularProgress size={16} />
            ) : (
              <Close color="error" />
            )}
          </IconButton>
        </ValueCell>
      </Row>
    </RowGroup>
  );
};

NewRateElement.propTypes = {
  level: number.isRequired,
  usedElementNames: arrayOf(number).isRequired,
  parentId: number,
  onCreate: func.isRequired,
  onCancel: func.isRequired,
  parentSalesRate: number,
  parentCostRate: number,
};
